/* eslint-disable prettier/prettier */
import React from "react";

const Dashboard = ({ isActive }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3H10V12H3V3ZM14 3H21V8H14V3ZM14 12H21V21H14V12ZM3 16H10V21H3V16Z"
      stroke={isActive ? "#fff" : "#1A1B1B"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Dashboard;
